<template>
  <div class="generic_share_button_container">

	  <!-- SHARE OPTIONS -->
	  <div class="container">
	    <div class="row">
	      <div class="col-12">
	        <div class="generic_share_button">
	          <b-button
	          size="lg"
	          variant="secondary"
	          @click="handle_button_click"
	          >
	            <span
				v-if="button_text"
	            >{{button_text}}</span>

	            <span
				v-if="!button_text"
	            >Share</span>

	          </b-button>
	        </div>
	      </div>
	    </div>
	  </div>

  </div>
</template>

<script>

export default {
  name: 'generic_share_button',
  props: [
    'button_text',
  ],
  data () {
    return {
      
    }
  },
  methods: {
  	handle_button_click: function() {
  		this.$emit('generic_share_clicked');
  	}
  },
  components: {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

.generic_share_button_container {

	width: 100%;

	.generic_share_button {

		padding: 1em 0;
		width: 100%;

		button {
			width: 100%;
		  	text-transform: uppercase;
		}

	}
}

</style>



// WEBPACK FOOTER //
// src/components/social/generic_share_button.vue